export const theme = {
  breakpoints: ['320px', '768px', '1280px'],
  colors: {
    PrimaryWhite: '#FFFFFF',
    PrimaryBlack: '#000000',
    PrimaryOrange: '#FF751D',
    PrimaryGray: '#F5F6FB',
    SecondGray: '#F6F7FB',
    PaleGray: '#C7CCDC',
    TextGray: '#52555F',
    BgGray: '#F2F5FC',
    BtnBorderGray: '#F6F7FC',
    PaleOrange: '#FFDAC0',
    Red: '#E53935',
    Green: '#407946',
    SVGColor: '#071F41',
    logoGrey: '#52555F',
    placeholderGrey: '#A6ABB9',
    inputErrorRed: '#eb5757',
  },
};
